document.addEventListener('DOMContentLoaded', function() {
  var readMoreButton = document.querySelector('.read-more-toggle');
  var fullDescription = document.getElementById('collection-description-full');

  if (readMoreButton && fullDescription) {
    readMoreButton.addEventListener('click', function(event) {
      event.preventDefault();

      if (fullDescription.style.display === 'none' || fullDescription.style.display === '') {
        fullDescription.style.display = 'block';
        readMoreButton.textContent = 'Read Less';
      } else {
        fullDescription.style.display = 'none';
        readMoreButton.textContent = 'Read More';
      }
    });
  }
});